import React from 'react';
import { BLOCKING_REASON_TYPES } from '@24i/nxg-sdk-photon';
import { defaultIconStyle } from './styled';
import { IconName, StyledIcon as Icon } from '../../../../Icons';
export const BlockingMessageIcon = ({ blockingReason, style = defaultIconStyle, }) => {
    switch (blockingReason) {
        case BLOCKING_REASON_TYPES.GEO_TYPE:
            return React.createElement(Icon, { name: IconName.geoblock, style });
        default:
            return null;
    }
};
//# sourceMappingURL=index.js.map